import { useMemo } from 'react';

import { useFlag } from '../../../services/launchDarkly';
import { useStores } from '../../../stores/useStores';
import type { UpcomingDailyMissionWidgetData, WidgetEntry } from '../types';

export function useUpcomingDailyMissionWidgets() {
  const { dailyMissionsStore } = useStores();
  const dailyMissionsFF = useFlag('daily_missions_feature', true);
  const { currentDailyMission } = dailyMissionsStore;

  const upcomingDailyMissionWidgets: UpcomingDailyMissionWidgetData[] = useMemo(() => {
    const showUpcomingDailyMission = Boolean(dailyMissionsFF && currentDailyMission?.status === 'UPCOMING');
    if (!showUpcomingDailyMission || !currentDailyMission) {
      return [];
    }
    return [
      {
        key: 'daily-mission',
        event: currentDailyMission,
        dataTestId: 'daily-mission-widget',
      },
    ];
  }, [currentDailyMission, dailyMissionsFF]);

  return useMemo(
    () =>
      upcomingDailyMissionWidgets.map(
        (data): WidgetEntry<'upcomingDailyMission'> => ({ data, type: 'upcomingDailyMission', id: data.key }),
      ),
    [upcomingDailyMissionWidgets],
  );
}
